import React, { useState, useEffect } from "react";
import "./Charger.css";

const ACChargerDetails = ({
  title,
  model,
  description,
  image,
  onDownload,
  onEnquire,

  // Optional props
  accordionSections = [], // [{ id, title, content, showFeatures }]
  features = [],
  locations = [],
  powerRating = "",
  showPowerBadge = false,
}) => {
  // Track open accordion (only one at a time)
  const [openSections, setOpenSections] = useState({});

  /* Open FIRST accordion by default */
  useEffect(() => {
    if (accordionSections.length > 0) {
      const initialState = {};
      accordionSections.forEach((section, index) => {
        initialState[section.id || section.title] = index === 0;
      });
      setOpenSections(initialState);
    }
  }, [accordionSections]);

  /* Toggle logic: ONLY ONE OPEN */
  const toggleSection = (sectionId) => {
    setOpenSections((prev) => {
      const isOpen = prev[sectionId];
      const newState = {};

      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });

      if (!isOpen) {
        newState[sectionId] = true;
      }

      return newState;
    });
  };

  return (
    <section className="ac-charger-details">
      {/* IMAGE */}
      <div className="image">
        <img src={image} alt={title} />
      </div>

      {/* CONTENT */}
      <div className="details content">
        <h1>{title}</h1>
        {model && <h2 className="model-name">{model}</h2>}

        {/* MULTIPLE ACCORDIONS */}
        {accordionSections.length > 0 ? (
          <div className="accordion-container">
            {accordionSections.map((section) => {
              const id = section.id || section.title;
              const isOpen = openSections[id];

              return (
                <div key={id} className="accordion-item">
                  <div
                    className="accordion-header"
                    onClick={() => toggleSection(id)}
                  >
                    <span className="accordion-title">
                      {section.title}
                    </span>
                    <span className="accordion-icon">
                      {isOpen ? "▲" : "▼"}
                    </span>
                  </div>

                  {isOpen && (
                    <div className="accordion-body">
                      {Array.isArray(section.content) ? (
                        <div className="specs-table">
                          {section.content.map((item, idx) => (
                            <div key={idx} className="spec-row">
                              <span className="spec-label">{item.label}</span>
                              <span className="spec-value">{item.value}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>{section.content}</p>
                      )}
                      {section.showFeatures && features.length > 0 && (
                        <ul className="features-list">
                          {features.map((feature, idx) => (
                            <li key={idx}>{feature}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          /* SINGLE ACCORDION (BACKWARD COMPATIBLE) */
          <div className="accordion">
            <div
              className="accordion-header"
              onClick={() =>
                setOpenSections({ main: !openSections.main })
              }
            >
              {model || "Details"}
              <span>{openSections.main ? "▲" : "▼"}</span>
            </div>

            {openSections.main && (
              <div className="accordion-body">
                <p>{description}</p>

                {features.length > 0 && (
                  <>
                    <h4 className="features-title">Key Features</h4>
                    <ul className="features-list">
                      {features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {/* POWER BADGE */}
        {showPowerBadge && powerRating && (
          <div className="power-badge">{powerRating}</div>
        )}

        {/* ACTION BUTTONS */}
        <div className="buttons">
          <button onClick={onDownload}>Download</button>
          <button onClick={onEnquire}>Enquire Now</button>
        </div>
      </div>
    </section>
  );
};

export default ACChargerDetails;
